import { Inset } from "@radix-ui/themes";
import AddBottomSpace from "../../components/AddBottomSpace";
import AddHeadline from "../../components/AddHeadline";
import AddTopSpace from "../../components/AddTopSpace";
import ZHistoryBanner from "./ZHistoryBanner";
import ZHistoryText from "./ZHistoryText";

export default function History() {

  return (
    <>
      <AddTopSpace />
      <AddHeadline />
      <div className="container">

        <div className='row'>
          <div className='col-lg-4'>
            <div className="container py-3">

              <div className='row pb-1'>
                <div className='col'>
                  <ZHistoryBanner />
                </div>
              </div>

              <div className='row py-3'>
                <div className='col'>
                  <Inset clip="padding-box" side="top" pb="current">
                    <img
                      src="https://www.shadvala.org/img/interstices-history.jpg"
                      alt="History"
                      style={{
                        display: 'block',
                        objectFit: 'cover',
                        width: '40%',
                        height: '40%',
                        backgroundColor: 'var(--gray-5)',
                      }}
                    />
                  </Inset>
                </div>
              </div>

            </div>
          </div>
          
          <div className='col-lg-8'>
            <ZHistoryText />
          </div>
        </div>

      </div>
      
      <AddBottomSpace />
    </>
  )
}
